import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import EditEvent from "../components/editTicket";
import UserProfileForm from "../components/updateForm";
import TransferFlowForm from "../components/transferFlow";
import CancelTransferForm from "../components/canceltf";
import DeleteButton from "../components/deleteButton";
import TransferDesignForm from "../components/transferdes";

export default function Foryou() {
  const [showDetailo, setShowDetailo] = useState(false);
  const { user, chatData } = useAuth();
  return (
    <div>
      {/* HEADER & TABS */}
      <div style={{ backgroundColor: "rgb(22, 19, 22)" }}>
        <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
          <div className="mx-auto">
            <p className="ml-6 text-md font-medium text-gray-200">Manager</p>
          </div>
        </div>
      </div>
      <div className="h-[85vh] overflow-y-scroll scroll-smooth">
        <UserProfileForm />

        <div className="px-2 mt-4 border-b-4 border-blue-950 border-dotted pb-2">
          <div className="flex justify-between">
            <p className="text-lg font-semibold">TRANSFER SECTION</p>
            <p className="text-lg font-bold">Mails: {user?.mail_count}</p>
          </div>

          <TransferFlowForm />

          {chatData?.transfer === "yes" ? <CancelTransferForm /> : ""}

          {/* <div className="text-center mt-4 mb-6">
            <div>
              <p className="text-md font-medium MB-1">TRANSFER DESIGN</p>
              <select className="w-3/6 mb-2 p-2 border border-black rounded">
                <option value={chatData?.tf_des}>{chatData?.tf_des}</option>
                <option value="sent">sent</option>
                <option value="claimed">claimed</option>
              </select>
            </div>
            <div>
              <button
                type="submit"
                className="bg-teal-700 px-4 py-2 rounded-lg text-white"
              >
                Update
              </button>
            </div>
          </div> */}

          {chatData?.transfer === "yes" ? <TransferDesignForm /> : ""}
        </div>

        <div className="px-4 mt-4 pb-8">
          <p className="text-lg font-semibold">MY EVENTS</p>
          {chatData ? (
            <div>
              <div className="w-full border px-4 text-gray-200 bg-cyan-900 rounded-lg mt-2 py-2">
                <div>{chatData?.event_name}</div>
              </div>
              <div className="flex gap-1 mt-1">
                <div>
                  {" "}
                  <p
                    className="border text-white bg-slate-950 rounded-md py-2 px-4"
                    onClick={() => setShowDetailo(true)}
                  >
                    Edit
                  </p>
                </div>

                <DeleteButton />
              </div>
            </div>
          ) : (
            "No events created"
          )}
        </div>
      </div>

      {/* SLIDING DETAILS TAB */}
      {showDetailo && <EditEvent onClose={() => setShowDetailo(false)} />}
    </div>
  );
}
